import { Text, Title } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import { PAP_Dismiss_AddAppsModal } from "@mirage/analytics/events/types/dismiss_add_apps_modal";
import { PAP_Shown_AddAppsModal } from "@mirage/analytics/events/types/shown_add_apps_modal";
import { useSuggestedConnectors } from "@mirage/growth/onboarding/hooks/useSuggestedConnectors";
import { ConnectorsModal } from "@mirage/growth/onboarding/self-serve-onboarding/ConnectorsModal";
import { useDoOnceOnMount } from "@mirage/shared/hooks/useDoOnceOnMount";
import i18n from "@mirage/translations";
import { useCallback } from "react";
import styles from "./AddAppsModal.module.css";

type Props = {
  open: boolean;
  onClose?: () => void;
};

export const AddAppsModal = ({ open, onClose = () => {} }: Props) => {
  const { reportPapEvent } = useMirageAnalyticsContext();

  const { allConnectors, loading } = useSuggestedConnectors();

  useDoOnceOnMount(() => {
    reportPapEvent(
      PAP_Shown_AddAppsModal({
        featureLine: "onboarding",
      }),
    );
  });

  const onCloseModal = useCallback(() => {
    reportPapEvent(
      PAP_Dismiss_AddAppsModal({
        featureLine: "onboarding",
      }),
    );
    onClose?.();
  }, [onClose, reportPapEvent]);

  const header = (
    <Box marginBottom="Macro Medium" display="flex" flexDirection="column">
      <Title
        className={styles.addAppsSubHeader}
        size="small"
        weightVariant="emphasized"
      >
        {i18n.t("add_apps_modal_welcome")}
      </Title>
      <Title
        className={styles.addAppsHeader}
        size="large"
        weightVariant="emphasized"
      >
        {i18n.t("add_apps")}
      </Title>
      <Text size="large">{i18n.t("add_apps_modal_welcome_sub_header")}</Text>
    </Box>
  );

  return (
    <ConnectorsModal
      connectors={allConnectors}
      loading={loading}
      open={open}
      onClose={onCloseModal}
      header={header}
    />
  );
};
